import { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import FormatCurrency from 'components/Common/FormatCurrency'
import GeoContext from 'contexts/geoContext'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import getRegionSaveAmountCopy from 'luxPlus/lib/getRegionSaveAmountCopy'
import useLuxPlusMonthTakeoverEnabledVerticals from '../hooks/useLuxPlusMonthTakeoverEnabledVerticals'

interface Props {
  /** This bullet's copy has no interpolated amount, so it's just a visibility gate */
  showSavingsBenefit: boolean
  joinFee: number
  /** Whether to include the 5 always-on year-round benefits, or just the two campaign-specific ones */
  showAdditionalBenefits: boolean
}

function LuxPlusMonthTakeoverBenefitsList(props: Props) {
  const { showSavingsBenefit, joinFee, showAdditionalBenefits } = props
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const { flights: flightsEnabled, cruises: cruisesEnabled } = useLuxPlusMonthTakeoverEnabledVerticals()
  const regionSaveAmountCopy = getRegionSaveAmountCopy(currentRegionCode, intl)

  return <>
    {showSavingsBenefit && <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
      {flightsEnabled ? (
        <FormattedMessage
          id="4vHJgqrprHgynG0fy-h6"
          defaultMessage="Save {regionSaveAmountCopy} each year with member-only pricing across hotels, flights, tours and more^"
          
          values={{ regionSaveAmountCopy }}
        />
      ) : (
        <FormattedMessage
          id="sqeSZAX6KCEA0Fn6xEDd"
          defaultMessage="Save {regionSaveAmountCopy} each year with member-only pricing across hotels, tours and more^"
          
          values={{ regionSaveAmountCopy }}
        />
      )}
    </BodyTextBlock>}
    {joinFee > 0 && <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
      <FormattedMessage
        id="X9yk9Fxr2MTwE8ubptfz"
        defaultMessage="{joinFee} joining fee waived"
        
        values={{ joinFee: <FormatCurrency format="roundedDollar" value={joinFee} /> }}
      />
    </BodyTextBlock>}
    {showAdditionalBenefits && <>
      <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
        <FormattedMessage
          id="5UfAHKJ9XMSR-JN2ap-8"
          defaultMessage="Bonus inclusions: hotel credit, daily breakfast, upgrades & more on select hotels"
          
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
        <FormattedMessage
          id="yh7MvLB-oBYv9OUuvUY3"
          defaultMessage="Early access to our bestselling offers"
          
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
        <FormattedMessage
          id="HOS4Jjc2qj1ksnqtlfg2"
          defaultMessage="Hidden offers, just for members"
          
        />
      </BodyTextBlock>
      {cruisesEnabled && <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
        <FormattedMessage
          id="Lku87_29dh5LToOIsdbJ"
          defaultMessage="Bonus onboard credit on select cruises"
          
        />
      </BodyTextBlock>}
      <BodyTextBlock variant="medium" startIcon={<SolidCheckCircleIcon colour="lux-plus" />}>
        <FormattedMessage
          id="vmGj-1ZqOuN9PwRhIKXs"
          defaultMessage="Priority 24/7 customer support"
          
        />
      </BodyTextBlock>
    </>}
  </>
}

export default LuxPlusMonthTakeoverBenefitsList
